import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { IConversationTransferStep } from "@/interfaces/conversation-transfer.interfaces";

type Props = {
  step: IConversationTransferStep;
  inset?: boolean;
};

export function TransferStepLabel({ step, inset = true }: Props) {
  return (
    <MDBox display="flex" alignItems="center" gap={0.5} minWidth={0} ml={inset ? 1 : 0}>
      <MDTypography variant="button" fontWeight="regular" color="dark" noWrap>
        {step.workflowName}
      </MDTypography>
      <ArrowRightAltIcon
        sx={{ fontSize: 18, color: "text.secondary", flexShrink: 0 }}
        aria-hidden
      />
      <MDTypography variant="button" fontWeight="medium" color="dark" noWrap>
        {step.stepName}
      </MDTypography>
    </MDBox>
  );
}
